import { render, staticRenderFns } from "./DrawableInfoList.vue?vue&type=template&id=2f21e9f4&scoped=true"
import script from "./DrawableInfoList.vue?vue&type=script&lang=js"
export * from "./DrawableInfoList.vue?vue&type=script&lang=js"
import style0 from "./DrawableInfoList.vue?vue&type=style&index=0&id=2f21e9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21e9f4",
  null
  
)

export default component.exports